import { render, staticRenderFns } from "./list.vue?vue&type=template&id=4895f284&scoped=true"
import script from "./list.vue?vue&type=script&setup=true&lang=js"
export * from "./list.vue?vue&type=script&setup=true&lang=js"
import style0 from "./list.vue?vue&type=style&index=0&id=4895f284&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4895f284",
  null
  
)

export default component.exports